import { colors, fonts } from "../../constants/theme";
import { COMPANY_CONTACT } from "../../constants/data";
import logoMark from "../../assets/logo-mark.png";

const SocialIcons = {
  instagram: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
    </svg>
  ),
  linkedin: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
      <rect x="2" y="9" width="4" height="12" />
      <circle cx="4" cy="4" r="2" />
    </svg>
  ),
  whatsapp: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
    </svg>
  ),
  facebook: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
    </svg>
  )
};

export default function Footer({ onNavigate }) {
  return (
    <footer
      style={{
        background: "#030a05",
        padding: "5rem 24px 2.5rem",
        position: "relative"
      }}
    >
      <style>{`
        @media (max-width: 768px) {
          footer {
            padding: 3.5rem 14px 2rem !important;
          }
        }
      `}</style>
      <div style={{ width: "min(1280px, 100%)", margin: "0 auto" }}>
        <div className="footer-row" style={{ paddingBottom: "2.5rem", borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
          {/* Brand */}
          <div style={{ display: "flex", alignItems: "center", gap: ".8rem" }}>
            <img src={logoMark} alt="" style={{ width: 40, height: 40, objectFit: "contain", filter: `drop-shadow(0 0 10px ${colors.lime}45)` }} />
            <div>
              <span style={{ fontFamily: fonts.display, fontWeight: 800, fontSize: "1.4rem", color: "#ffffff" }}>
                VittaLink
              </span>
              <div style={{ fontSize: "10px", fontWeight: 700, color: colors.lime, letterSpacing: ".1em" }}>
                EXPANDIENDO NUTRICIÓN
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div style={{ display: "flex", gap: "2rem", fontSize: ".9rem", color: colors.gray, flexWrap: "wrap", alignItems: "center" }}>
            <a
              href="/"
              onClick={(e) => {
                e.preventDefault();
                if (onNavigate) onNavigate("catalog");
              }}
              style={{ transition: "color .2s", cursor: "pointer" }}
              onMouseEnter={e => e.target.style.color = colors.lime}
              onMouseLeave={e => e.target.style.color = colors.gray}
            >
              Catálogo
            </a>
            <a
              href="/"
              onClick={(e) => {
                e.preventDefault();
                if (onNavigate) {
                  onNavigate("home");
                  setTimeout(() => {
                    const el = document.querySelector("#objetivos");
                    if (el) el.scrollIntoView({ behavior: "smooth" });
                  }, 100);
                }
              }}
              style={{ transition: "color .2s" }}
              onMouseEnter={e => e.target.style.color = colors.lime}
              onMouseLeave={e => e.target.style.color = colors.gray}
            >
              Objetivos
            </a>
            <a
              href="/"
              onClick={(e) => {
                e.preventDefault();
                if (onNavigate) {
                  onNavigate("home");
                  setTimeout(() => {
                    const el = document.querySelector("#app");
                    if (el) el.scrollIntoView({ behavior: "smooth" });
                  }, 100);
                }
              }}
              style={{ transition: "color .2s" }}
              onMouseEnter={e => e.target.style.color = colors.lime}
              onMouseLeave={e => e.target.style.color = colors.gray}
            >
              App Móvil
            </a>
            <a
              href="/"
              onClick={(e) => {
                e.preventDefault();
                if (onNavigate) {
                  onNavigate("team");
                }
              }}
              style={{ transition: "color .2s" }}
              onMouseEnter={e => e.target.style.color = colors.lime}
              onMouseLeave={e => e.target.style.color = colors.gray}
            >
              Equipo
            </a>
          </div>

          {/* Síguenos / Socials */}
          <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
            <span style={{ fontSize: ".85rem", fontWeight: 700, color: colors.lime, letterSpacing: ".05em" }}>
              Síguenos:
            </span>
            <div style={{ display: "flex", gap: ".6rem" }}>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: "50%",
                  background: "rgba(255,255,255,0.06)",
                  border: "1px solid rgba(255,255,255,0.1)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#f8fafc",
                  transition: "all .25s ease"
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.background = "rgba(200, 241, 53, 0.2)";
                  e.currentTarget.style.color = colors.lime;
                  e.currentTarget.style.borderColor = colors.lime;
                  e.currentTarget.style.transform = "scale(1.1)";
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.background = "rgba(255,255,255,0.06)";
                  e.currentTarget.style.color = "#f8fafc";
                  e.currentTarget.style.borderColor = "rgba(255,255,255,0.1)";
                  e.currentTarget.style.transform = "scale(1)";
                }}
                title="Instagram"
              >
                {SocialIcons.instagram}
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: "50%",
                  background: "rgba(255,255,255,0.06)",
                  border: "1px solid rgba(255,255,255,0.1)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#f8fafc",
                  transition: "all .25s ease"
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.background = "rgba(200, 241, 53, 0.2)";
                  e.currentTarget.style.color = colors.lime;
                  e.currentTarget.style.borderColor = colors.lime;
                  e.currentTarget.style.transform = "scale(1.1)";
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.background = "rgba(255,255,255,0.06)";
                  e.currentTarget.style.color = "#f8fafc";
                  e.currentTarget.style.borderColor = "rgba(255,255,255,0.1)";
                  e.currentTarget.style.transform = "scale(1)";
                }}
                title="LinkedIn"
              >
                {SocialIcons.linkedin}
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: "50%",
                  background: "rgba(255,255,255,0.06)",
                  border: "1px solid rgba(255,255,255,0.1)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#f8fafc",
                  transition: "all .25s ease"
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.background = "rgba(200, 241, 53, 0.2)";
                  e.currentTarget.style.color = colors.lime;
                  e.currentTarget.style.borderColor = colors.lime;
                  e.currentTarget.style.transform = "scale(1.1)";
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.background = "rgba(255,255,255,0.06)";
                  e.currentTarget.style.color = "#f8fafc";
                  e.currentTarget.style.borderColor = "rgba(255,255,255,0.1)";
                  e.currentTarget.style.transform = "scale(1)";
                }}
                title="Facebook"
              >
                {SocialIcons.facebook}
              </a>
              <a
                href={`https://wa.me/${COMPANY_CONTACT.whatsappNumber}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: "50%",
                  background: "rgba(255,255,255,0.06)",
                  border: "1px solid rgba(255,255,255,0.1)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#f8fafc",
                  transition: "all .25s ease"
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.background = "rgba(200, 241, 53, 0.2)";
                  e.currentTarget.style.color = colors.lime;
                  e.currentTarget.style.borderColor = colors.lime;
                  e.currentTarget.style.transform = "scale(1.1)";
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.background = "rgba(255,255,255,0.06)";
                  e.currentTarget.style.color = "#f8fafc";
                  e.currentTarget.style.borderColor = "rgba(255,255,255,0.1)";
                  e.currentTarget.style.transform = "scale(1)";
                }}
                title="WhatsApp"
              >
                {SocialIcons.whatsapp}
              </a>
            </div>
          </div>
        </div>

        {/* Bottom copyright row */}
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", paddingTop: "1.8rem" }}>
          <span style={{ fontFamily: fonts.body, fontSize: ".83rem", color: "rgba(255,255,255,0.4)" }}>
            © {new Date().getFullYear()} VittaLink · República Dominicana · Todos los derechos reservados.
          </span>
        </div>
      </div>
    </footer>
  );
}
